module.exports = __webpack_public_path__ + "static/img/zavod_za_javno_zdravstvo_pgz.68e4f30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/zavod_za_javno_zdravstvo_pgz.jpg
// module id = V506
// module chunks = 0